import {createFileRoute} from '@tanstack/react-router';

import {CreateLayoutTemplateForm} from '@/features/Library/components/Location/CreateLayoutTemplateForm';
import {makeDocumentTitle} from '@/utils/makeDocumentTitle';

export const Route = createFileRoute('/_b/_p/_library/locations/create')({
  component: CreateLayoutTemplateForm,
  beforeLoad: () => makeDocumentTitle('Create Location Layout'),
});
